/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menuscanerrorbusy3Inputs */

const en_menuscanerrorbusy3 = /** @type {(inputs: Menuscanerrorbusy3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Too many attempts in a short time. Wait a minute, then try again.`)
};

const de_menuscanerrorbusy3 = /** @type {(inputs: Menuscanerrorbusy3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zu viele Versuche in kurzer Zeit. Warte eine Minute und versuch es dann noch einmal.`)
};

/**
* | output |
* | --- |
* | "Too many attempts in a short time. Wait a minute, then try again." |
*
* @param {Menuscanerrorbusy3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menuscanerrorbusy3 = /** @type {((inputs?: Menuscanerrorbusy3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menuscanerrorbusy3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menuscanerrorbusy3(inputs)
	return de_menuscanerrorbusy3(inputs)
});
export { menuscanerrorbusy3 as "menuScanErrorBusy" }